module.exports = __webpack_public_path__ + "static/personal3-590def2874b5084038ef1f14c184a62e.jpg";